'use client';

import Card from '@/components/atoms/Card';
import useAuth from '@/contexts/AuthProvider';
import { generateProductLink, renderLabel } from '@/services/ecommerce/utils/helper';
import { get, isEmpty } from 'lodash';
import Link from 'next/link';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import styles from './product.module.scss';

const OthersVerients = ({ data }) => {
	const { isB2B } = useAuth();
	const forwardData = get(data, 'reference.forward', {});
	const backwardData = get(data, 'reference.backward', {});
	const mergedData = [forwardData, backwardData].flat();
	const filteredData = mergedData.filter((item) => !isEmpty(item));
	if (!filteredData.length) {
		return null;
	}
	const userTypes = isB2B ? 'b2b' : 'b2c';

	return (
		<Card
			className='rounded-10 mt-20'
			title='Other Variants'
			bodyStyle={{
				padding: 0,
				marginBottom: 0
			}}>
			<div className='d-flex flex-column flex-wrap'>
				{filteredData.map((item, index) => {
					const pv = get(item, 'pv[0]', {});
					const pu = item.pu.find((item) => item.pu_p_id === pv.pv_p_id);

					const price = get(pv, `pv_${userTypes}_discounted_price`, 0);
					const mrp = get(pv, `pv_mrp`, 0);
					const discountInPercent = Math.round(((mrp - price) / mrp) * 100);
					const label = renderLabel({
						qty: 1,
						salesUnit: pu.pu_label,
						baseUnit: pu.pu_label,
						unitMultiplier: pu.pu_multiplier
					});

					return (
						<div
							key={index}
							className='d-flex justify-space-between items-center'
							style={{
								borderBottom: index === filteredData.length - 1 ? 'none' : '1px solid #e2e8f0',
								paddingInline: 20,
								paddingBlock: 10
							}}>
							<div className='text-16 text-primary'>{label}</div>
							<div className='d-flex gap-10 items-center'>
								<del
									style={{
										color: '#A0AEC0'
									}}>
									৳{pv?.pv_mrp}
								</del>
								<span className='text-error fw-600'>{discountInPercent}%OFF</span>
								<span className='text-grey900 fw-600'>৳{price}</span>

								<div className={styles.other_verientsnext}>
									<Link className={styles.other_verientsnext} href={generateProductLink(item)}>
										<MdOutlineKeyboardArrowRight size={24} />
									</Link>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</Card>
	);
};

export default OthersVerients;
